import { render, staticRenderFns } from "./mInputNumber.vue?vue&type=template&id=3fc5856a&"
import script from "./mInputNumber.vue?vue&type=script&lang=js&"
export * from "./mInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports